export function clickedInsideElementBoundingRect(e: MouseEvent, el: HTMLElement): boolean {
	const rect = el.getBoundingClientRect();
	return rect.top <= e.clientY && e.clientY <= rect.top + rect.height && rect.left <= e.clientX && e.clientX <= rect.left + rect.width;
}
